module.exports = __webpack_public_path__ + "static/media/vial-ban-icon.d972189c.png";


//////////////////
// WEBPACK FOOTER
// ./src/componentes/_util/icons/custom/vial-ban-icon.png
// module id = 3009
// module chunks = 1